import * as React from "react";
import { useCopy } from "../../containers";
import { useThemedAsset } from "../../hooks/use-themed-asset";

import "./home.scss";
import { Link } from "react-router-dom";
import { Button } from "../../atoms/Button/button";

interface IHomeProps {
  copy: {
    title: string;
    description: string;
    shopLinkLabel: string;
  };
}
const Home: React.FC<IHomeProps> = ({
  copy: { title, description, shopLinkLabel } = {}
}) => {
  const baseClassName = "home";
  const assetIllustration = useThemedAsset(
    "/images/{theme}/home/illustration.svg"
  );

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__illustration`}>
        <img
          className={`${baseClassName}__image`}
          src={assetIllustration}
          alt=""
        />
      </div>
      <div className={`${baseClassName}__title`}>
        <h1 className={`${baseClassName}__heading`}>{title}</h1>
      </div>
      <div className={`${baseClassName}__description`}>
        <p>{description}</p>
      </div>
      <Button tag={Link} to="/shop" theme="outline-primary">
        {shopLinkLabel}
      </Button>
    </div>
  );
};

export const HomeContainer = (props: any) => {
  const copy = useCopy("home");

  return <Home {...props} copy={copy} />;
};
